<template>
    <el-carousel :height="height" :trigger="trigger">
        <el-carousel-item v-for="(item, index) in value" :key="index">
            <img :src="item.imgUrl" alt="" class="img" @click="change(item)">
        </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
  name: 'banner',
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    height: {
      type: String
    },
    trigger: {
      type: String
    }
  },
  methods: {
    change (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>
    .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    img {
        /*object-fit: cover;*/
        /*object-position: center;*/
        background-size: cover;
    }
</style>
